import CustomFieldTypes from '@/constants/customFields/CustomFieldTypes';
import translate from '@/lib/intl/translate';

export const ALL_CONSTITUENTS_VALUE = 'all-constituents';
export const SELECT = 'select';
export const FIELD_TYPE_OPTIONS = [
  {
    value: CustomFieldTypes.CHECKBOX,
    text: translate('CUSTOM_FIELDS_CHECKBOX'),
  },
  {
    value: CustomFieldTypes.DATE_PICKER,
    text: translate('CUSTOM_FIELDS_DATE_PICKER'),
  },
  {
    value: SELECT,
    text: translate('CUSTOM_FIELDS_LIST'),
  },
  {
    value: CustomFieldTypes.TEXT_SINGLE,
    text: translate('CUSTOM_FIELDS_TEXT_SINGLE'),
  },
  {
    value: CustomFieldTypes.TEXT_MULTI,
    text: translate('CUSTOM_FIELDS_TEXT_MULTIPLE'),
  },
];

export const RESPONSE_TYPE_OPTIONS = [
  {
    value: CustomFieldTypes.LIST_SINGLE,
    text: translate('CUSTOM_FIELDS_SINGLE_SELECT'),
  },
  {
    value: CustomFieldTypes.LIST_MULTI,
    text: translate('CUSTOM_FIELDS_MULTI_SELECT'),
  },
];
